// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M4 8C4 3.58172 7.58172 0 12 0C16.4183 0 20 3.58172 20 8V12.6972L22 15.6972V20H2V15.6972L4 12.6972V8ZM11 6V12H13V6H11ZM13.0039 13.5H11V15.5039H13.0039V13.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M8.64453 21C9.07481 22.4457 10.4141 23.5 11.9996 23.5C13.5851 23.5 14.9244 22.4457 15.3547 21H8.64453Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-notification-error-filled')
export default class NotificationErrorFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'notification-error-filled',
    }
  }
}
